<template>
    <div id="invoiceModal" ref="addCustomerModal" class="modal fade">
      <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content">
          <!-- ----------------------------------------------- -->
          <div class="modal-header">
            <h5 class="modal-title select">Invoice: {{ invoice._id }}</h5>
            <a class="btn-close" data-bs-dismiss='modal'></a>
          </div>
          <!-- ----------------------------------------------- -->
          <div class="modal-body" id="invoice_container">
            <vue3-html2pdf
              :show-layout="true"
              :float-layout="false"
              :enable-download="false"
              :preview-modal="true"
              :manual-pagination="false"
              :paginate-elements-by-height="1400"
              :filename="`Invoice-${invoice._id}.pdf`"
              :pdf-quality="2"
              pdf-format="A4"
              pdf-orientation="portrait"
              pdf-content-width="100%"
              :html-to-pdf-options="options"
              html
              ref="invoice_body"
            >
              <template v-slot:pdf-content>
                <div class="container" id="invoice_body">
                  <div class="row">
                    <div class="col text-center">
                      <img class="w-50" draggable="false" src='@/assets/logo.png'>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col text-center">
                      <hr class="my-1">
                      <p class="text-center fw-bold">Sales Invoice</p>
                      <hr class="my-1">
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-2 py-0">
                      <p class="text-start m-0">Date</p>
                    </div>
                    <div class="col-6 py-0">
                      <p class="text-start m-0">{{ invoice.date }}</p>
                    </div>
                    <div class="col-4 py-0">
                      <p class="text-start m-0">Branch: {{ invoice.branch }}</p>
                    </div>
                  </div>
                  
                  <div class="row">
                    <div class="col-2 py-0">
                      <p class="text-start m-0">Customer</p>
                    </div>
                    <div class="col-6 py-0">
                      <p class="text-start m-0">{{ invoice.customerName }} {{ invoice.customerPhone }}</p>
                    </div>
                    <div class="col-4 py-0">
                      <p class="text-start m-0">Cashier: {{ invoice.cashier }}</p>
                    </div>
                  </div>

                  <div v-if="invoice.car">

                    <div class="row">
                      <div class="col-2 py-0">
                        <p class="text-start m-0">Car</p>
                      </div>
                      <div class="col-6 py-0">
                        <p class="text-start m-0">{{ invoice.car.brand }} {{ invoice.car.plate.join(' ') }}</p>
                      </div>
                      <div class="col-4 py-0">
                        <p class="text-start m-0">Milage: {{ formatThousand(invoice.car.miles) }} Km</p>
                      </div>
                    </div>

                  </div>

                  <div class="row">
                    <div class="col text-center">
                      <hr class="py-1">
                      <table class="table table-sm border-dark unselect align-middle">
                        <thead>
                          <tr class="table-secondary border-dark">
                            <th class="text-start w-55">Item</th>
                            <th class="text-center w-15">Price</th>
                            <th class="text-center w-15">Quantity</th>
                            <th class="text-center w-15">Value</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="x, i in invoice.items" :key="i" class="border-dark">
                            <td class="text-start w-55">
                              {{ x.name }}
                              <span v-if="x.prod_date" class='subtitle'>Production Date: {{ x.prod_date }}</span>
                            </td>
                            <td class="text-center w-15">{{ x.price }}</td>
                            <td class="text-center w-15">{{ x.quantity }}</td>
                            <td class="text-center w-15">
                              <span v-bind:class="x.discount ? 'text-decoration-line-through' : ''">
                                {{ (x.price * x.quantity).toFixed(2) }}
                              </span>
                              <span v-if="x.discount" class="d-block">
                                {{ x.value.toFixed(2) }}
                              </span>
                            </td>
                          </tr>

                          <tr class="table-secondary fw-bold">
                            <td class="text-start w-50">Tax {{ invoice.tax }}%</td>
                            <td colspan="3" class="text-center w-45">{{ formatMoney(invoice.subtotal * (invoice.tax||0)/100) }} EGP</td>
                          </tr>
                          <tr v-if="invoice.delivery_fees > 0" class="fw-bold">
                            <td class="text-start w-50">Delivery</td>
                            <td colspan="3" class="text-center w-45">{{ formatMoney(invoice.delivery_fees) }} EGP</td>
                          </tr>
                          <tr class="table-secondary fw-bold">
                            <td class="text-start w-50">Total</td>
                            <td colspan="3" class="text-center w-45">{{ formatMoney(invoice.total) }} EGP</td>
                          </tr>

                          <tr>
                            <td colspan="4">
                            </td>
                          </tr>

                          <tr v-for="payment in invoice.payments" :key="payment._id" class="table-secondary fw-bold">
                            <td class="text-start w-50">
                              Paid {{ payment.method }} {{ payment.method == 'visa' ? `(${payment.ref_num})` : '' }} : <span class="fw-normal">{{ payment.date_paid }}</span></td>
                            <td colspan="3" class="text-center w-45">{{ formatMoney(payment.value) }} EGP</td>
                          </tr>
                          <tr v-if="invoice.left > 0" class="table-secondary fw-bold">
                            <td class="text-start w-50">Remaining</td>
                            <td colspan="3" class="text-center w-45">{{ formatMoney(invoice.left) }} EGP</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col text-center">
                      <hr class="pb-0">
                      <span v-if="invoice.returned" class="d-block p-0 text-danger f-bold">This invoice has returns !!</span>
                      <svg class="barcode w-50" ref="invoiceBarcode"></svg>
                    </div>
                  </div>

                </div>
              </template>
            </vue3-html2pdf>
          </div>
          <!-- ----------------------------------------------- -->
          <div class="modal-footer">
            <div class="container">
              <div class="row">
                <div class="col text-center">
                  <button class="btn btn-success bi-printer-fill w-50" @click="printInvoice()">
                    &nbsp;
                    <span v-if="loading" class="spinner-border"></span>
                    <span>Print</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <!-- ----------------------------------------------- -->
        </div>
      </div>
    </div>
</template>
<!-- ******************************************************** -->
<script>
    import Vue3Html2pdf from 'vue3-html2pdf'
    const $ = require('jquery');
    var JsBarcode = require("jsbarcode");
    export default {
        // eslint-disable-next-line
        name: 'Invoice',
        components: {
            Vue3Html2pdf
        },
        data(){
          return {
            invoice:{
              _id: '',
              total: 0,
            },
            options:{
              filename: '',
              margin: 7,
              html2canvas: { 
                scale: 2, 
                letterRendering: false
              },
            }
          }
        },
        created(){
        },
        methods:{
          //**********************************************************
          async view(invoice_id){
            var ack = await this.$service.getInvoice({ id: invoice_id });
            if(ack.state != 'OK'){
              this.$toast(ack.state);
            }
            else{
              this.invoice = ack.data;
              JsBarcode(this.$refs.invoiceBarcode, this.invoice._id);
              $('#invoiceModal').modal('show');
            }
          },
          //**********************************************************
          async printInvoice(){
            this.$refs.invoice_body.generatePdf();
              // var invoiceBody = $('#invoice_body')[0].innerHTML;
              // let scale = 5;
              // let width = 210 * scale, height = 297 * scale;
              // let left = (window.innerWidth - 210) / 2;
              // let top = (window.innerHeight - 297) / 2;
              // const printWindow = window.open('', '', `left=${left},top=${top},width=${width},height=${height},toolbar=0,scrollbars=0,status=0`);
              // let css = Array.from($('link[rel="stylesheet"], style')).reduce((acc, node)=>acc + node.outerHTML, '');
              // printWindow.document.write(`
              //     <head>${css}</head>
              //     <body>${invoiceBody}</body>
              // `);
              // printWindow.document.close();
              // printWindow.focus();

              // printWindow.print();
              // await new Promise((res)=>setTimeout(res, 500));
              // printWindow.close();
          }
        }
    }
</script>
<!-- ******************************************************** -->
<style scoped>
#invoice_body > p{
    margin: none !important;
}
</style>
  